import { Formik, Form } from 'formik'
import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { useQuery } from '@tanstack/react-query'
import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import Table from '../../../../components/Table'
import { formatAddress } from '../../../../util/string'
import { FiFileText, FiPlus, FiUserCheck } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'
import Modal from '../../../../components/Modal'
import { Button, Textbox } from '../../../../components/Form'
import FormEndereco from '../../../../components/FormEndereco/v2'
import masks from '../../../../util/masks'
import formUtils from '../../../../util/form'

const baseInitialValues = {
	nome: '',
	fone: '',
	email: '',
	cnpj: '',
	cep: '',
	uf: '',
	cidade: '',
	bairro: '',
	logradouro: '',
	numero: '',
	complemento: ''
}

export default function () {
	const history = useHistory()

	const [showCadastro, setShowCadastro] = useState(false)
	const [initialValues, setInitialValues] = useState(baseInitialValues)

	const { data: parceiros, refetch: refetchParceiros } = useQuery({
		queryKey: ['get-parceiros'],
		queryFn: async () => {

			const response = await api.get('parceiro', authHeaders())

			return response.map(item => ({
				id: item.id,
				nome: item.pessoa.nome,
				cnpj: item.pessoa.documentos.find(d => d.tipo_documento_id === 14).identificador,
				endereco: formatAddress(item.pessoa.endereco),
				email: item.pessoa.contato.find(c => c.tipo_contato_id === 6).contato,
				fone: item.pessoa.contato.find(c => c.tipo_contato_id === 4).contato
			}))
		},
		enabled: !!authHeaders()
	})

	async function handleSubmit(values) {
		try {
			values = formUtils.extractFormValues(values)

			await api.post('parceiro', values, authHeaders())

			refetchParceiros()

			setShowCadastro(false)

			toast.success('Parceiro cadastrado com sucesso!')
		} catch (e) {
			toast.error(e.msg)
		}
	}

	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Parceiros</h1>

				<Button onClick={() => { setShowCadastro(true) }} className="w-fit self-end">
					Cadastrar novo
					<FiPlus size={16} />
				</Button>


				<Table
					headers={[
						{ name: 'nome', value: 'Nome' },
						{ name: 'cnpj', value: 'CNPJ', centered: true, style: { width: 160 } },
						{ name: 'email', value: 'E-mail', centered: true, style: { width: 220 } },
						{ name: 'fone', value: 'Fone', centered: true, style: { width: 124 } },
						{ name: 'endereco', value: 'Endereço', centered: true }
					]}
					data={parceiros}
					actions={[
						{
							action: item => {
								history.push(`/admin/parceiros/${item.id}/carga_usuarios`)
							},
							icon: FiFileText,
							iconSize: 16,
							name: 'Carregar planilha de usuários',
						},
						{
							action: item => {
								history.push(`/admin/parceiros/${item.id}/admins`)
							},
							icon: FiUserCheck,
							iconSize: 16,
							name: 'Gerenciar administradores'
						}
					]}
				/>
			</Card>

			<Modal
				isOpen={showCadastro}
				handleClose={() => { setShowCadastro(false) }}
				title="Cadastro de parceiro"
			>
				<Formik
					onSubmit={handleSubmit}
					initialValues={initialValues}
					enableReinitialize
				>
					{({ setFieldValue }) => (
						<Form className="flex flex-col gap-6">
							<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
								<Textbox
									name="nome"
									label="Nome"
								/>

								<Textbox
									name="cnpj"
									label="CNPJ"
									mask={masks.cnpj}
								/>

								<Textbox
									name="fone"
									label="Fone"
									mask={masks.mobile}
								/>

								<Textbox
									name="email"
									label="E-mail"
								/>
							</div>

							<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
								<FormEndereco setFieldValue={setFieldValue} />
							</div>

							<Button type="submit" className="self-end">
								Cadastrar
							</Button>
						</Form>
					)}
				</Formik>
			</Modal>
		</div>
	)
}
